// extracted by mini-css-extract-plugin
module.exports = {"link":"ClickToCopy_link__JcK8O","copy":"ClickToCopy_copy__Wczzd","copied":"ClickToCopy_copied__2s6Xo"};